import AdditionalDocumentModal from './AdditionalDocumentModal.component';

export type { AdditionalDocumentFormValues } from './AdditionalDocumentModal.component';

export default AdditionalDocumentModal;
